import { gsap } from '../LibrariesImport';

export default class SplashScreen {
	static init() {
		this.splashScreenEl = document.querySelector('.splash-screen');

		if (!this.splashScreenEl) {
			return;
		}

		this.pageContentEl = document.querySelector('.page-content');
		this.splashScreenContentEl = this.splashScreenEl.firstElementChild;

		const { height: splashScreenHeight } = this.splashScreenEl.getBoundingClientRect();

		gsap.fromTo(this.splashScreenEl, {
			filter: 'brightness(1)',
		}, {
			filter: 'brightness(0.6)',
			scrollTrigger: {
				trigger: this.splashScreenEl,
				start: 'top top',
				end: `${splashScreenHeight} top`,
				scrub: 1,
			},
		});
	}
}
